"use client";
import { jsx as s } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { FileInput as i } from "../../atoms/FileInput/FileInput.mjs";
const m = a(
  ({ children: t, state: e = "default", useButtonWrapper: p = !0, multiple: r, ...u }, o) => /* @__PURE__ */ s(
    i,
    {
      ref: o,
      state: e,
      useButtonWrapper: p && (e !== "success" || !!r),
      accept: "image/*",
      multiple: r,
      ...u,
      children: t
    }
  )
);
m.displayName = "ImageFileInput";
export {
  m as ImageFileInput
};
